import '.i{position:fixed;}.ssr-plugin'
import '.b1{top:0px;}.ssr-plugin'
import '.bb{left:0px;}.ssr-plugin'
import '.bc{right:0px;}.ssr-plugin'
import '.bd{bottom:0px;}.ssr-plugin'
import '.be{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.bf{z-index:998;}.ssr-plugin'
import '.bg{transition:opacity 0.3s ease;}.ssr-plugin'
import '.bh{height:100vh;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.bi{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.bj{z-index:999;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.bk{justify-content:space-between;}.ssr-plugin'
import '.bl{padding:1.5rem;}.ssr-plugin'
import '.bm{border-bottom:var(--border-default);}.ssr-plugin'
import '.as{flex-shrink:0;}.ssr-plugin'
import '.av{flex:1;}.ssr-plugin'
import '.bn{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="i b1 bb bc bd be bf bg"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="i b1 bh l t bi bj d e"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="d r bk bl bm as"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="av bn bl"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
